import { createSlice } from "@reduxjs/toolkit";

import { ProfileState } from "@/store/types";

import {
  getGrandidRef,
  getProfile,
  getSignIn,
  getSignInGrandid,
  getSignOut,
  getTodoList, requestOTP,
  verifyOTP,
} from '@/store/actions/profile-actions';
import { ServerError, UserSession } from "@/lib/types";
import cookies from "js-cookie";
import jwt_decode from "jwt-decode";

const access_token = cookies.get("access_token");

const initialState: ProfileState = {
  loading: false,
  error: "",
  session: access_token ? jwt_decode<UserSession>(access_token) : null,
  todos: [],
  grandid: null,
  user: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ============= sign in =============
      .addCase(getSignIn.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSignIn.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.session = payload;
      })
      .addCase(getSignIn.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // ============= sign grandId in =============
      .addCase(getSignInGrandid.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSignInGrandid.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.session = payload;
      })
      .addCase(getSignInGrandid.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // ============= sign out =============
      .addCase(getSignOut.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSignOut.fulfilled, (state) => {
        state.loading = false;
        state.session = null;
      })
      .addCase(getSignOut.rejected, (state, action: any & { payload: ServerError }) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // ============= profile =============
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getProfile.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload;
      })
      .addCase(getProfile.rejected, (state, { error }) => {
        state.loading = false;
      })
      // ============= get Sign with grand-id =============
      .addCase(getGrandidRef.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(getGrandidRef.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.grandid = payload;
      })
      .addCase(getGrandidRef.rejected, (state, { error }) => {
        state.loading = false;
      })
      // ============= get todo list =============
      .addCase(getTodoList.pending, (state) => {
        state.loading = false;
        state.todos = [];
        state.error = "";
      })
      .addCase(getTodoList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.todos = payload;
      })
      .addCase(getTodoList.rejected, (state, { error }) => {
        state.loading = false;
      })
      // =================== OTP ====================
      .addCase(requestOTP.pending, (state) => {
      state.loading = true;
      state.error = "";
      })
      .addCase(requestOTP.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(requestOTP.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ??
          action.error.message ??
          "OTP request failed";
      })
      .addCase(verifyOTP.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.session = action.payload;
        state.error = "";
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ??
          action.error.message ??
          "OTP verification failed";
      });
  }
});

export default profileSlice.reducer;
